// extracted by mini-css-extract-plugin
module.exports = {"no-records":"styles_no-records__1hHih"};